var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.865 1.996 1.357 2.96.112.244.265.041 3.107.486-2.271 2.382-.171.18.039.244.528 3.318-2.72-1.539-.246-.139-.246.14-2.722 1.538.528-3.318.039-.244-.17-.18L1.02 5.727l3.107-.486.266-.041.112-.244 1.359-2.96Z",
    stroke: "#111"
  })));
};
export default SvgStar;